import { TClassSummary } from '../../../../../types/utilityTypes';
import { TSpecSummary } from '../../../../../types/utilityTypes';
import { TSpecSelectViewOptions } from './types';
import { Stack } from '../../../../components/stack/Stack';
import { SpecIcon } from '../SpecIcon';
import cx from 'classnames';
import { formatSpecLabelWithViewConfig } from './lib';
import { ReactNode } from 'react';
import { Avatar } from '../../../../components/avatar/Avatar';

export interface ISpecOptionProps {
  spec: TSpecSummary;
  cls: TClassSummary;
  viewOptions: Required<TSpecSelectViewOptions>;
  optionExtraRender?: (spec: TSpecSummary) => ReactNode;
  context: 'menu' | 'value';
  iconSize?: number;
}

export const SpecOption = ({ spec, cls, viewOptions, optionExtraRender, context, iconSize = 18 }: ISpecOptionProps) => {
  return (
    <Stack alignItems="center" gap={8}>
      <Stack gap={8} alignItems="center" style={{ width: '100%' }}>
        <Avatar size={'auto'} border style={{ flexShrink: 0 }}>
          <SpecIcon spec={spec.slug} class={cls?.slug} size={iconSize} style={{ display: 'flex' }} />
        </Avatar>

        <span
          className={cx({
            [`class-color--${cls.slug}`]: viewOptions.classColor
          })}
        >
          {context === 'menu'
            ? formatSpecLabelWithViewConfig(spec, cls, viewOptions.menuValue)
            : formatSpecLabelWithViewConfig(spec, cls, viewOptions.selectedValue)}
        </span>
      </Stack>
      {optionExtraRender?.(spec)}
    </Stack>
  );
};
